import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import LoadingOverlay from 'react-loading-overlay';
import { ThemeProps, LoadingProps } from '../../shared/prop-types/ReducerProps';

class MainWrapper extends PureComponent {
  static propTypes = {
    theme: ThemeProps.isRequired,
    children: PropTypes.element.isRequired,
    loading: LoadingProps.isRequired,
  };

  render() {
    const { theme, loading, children } = this.props;
    return (
      <div className={theme.className}>
        <div className="wrapper">
          <LoadingOverlay
            active={loading.loadingQuantity > 0}
            spinner={
              <svg className="load__icon">
                <path
                  fill="#5b346d"
                  d="M12,4V2A10,10 0 0,0 2,12H4A8,8 0 0,1 12,4Z"
                />
              </svg>
            }
          >
            {children}
          </LoadingOverlay>
        </div>
      </div>
    );
  }
}

export default connect((state) => ({
  theme: state.theme,
  loading: state.loading,
}))(MainWrapper);
